import React from "react";

import styles from "../../../../styles/integrations.module.scss";
import sortStyles from '../../../../styles/sort-items.module.scss';
import bannerStyles from '../../../../styles/banners-drawer.module.scss';

import { Drawer } from "../../../components/Drawer";
import { Input } from "../../../components/Input";
import { Button } from "../../../components/Button";
import { CatalogAPI } from "../../../../providers/CatalogAPI";
import { ImageUpload } from "../../../components/ImageUpload";
import { EnvironmentsAPI } from "../../../../providers/EnvironmentsAPI";
import { EnvironmentStorage } from "../../../tools/EnvironmentStorage";
import { Hairline } from "../../../components/Hairline";
import { Icon } from "../../../components/core/Icon";

export default class HoldingBannersDrawer extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            active: true,
            merchantId: '',
            mobileBanners: [],
            desktopBanners: []
        };
    }

    async componentDidMount() {
        const frontTheme = await EnvironmentsAPI.getConfigurationsByAlias(
            await EnvironmentStorage.getEnvironmentHoldingId(),
            'front_theme'
        );

        this.setState({
            mobileBanners: frontTheme?.covers?.mobile || [],
            desktopBanners: frontTheme?.covers?.desktop || [],
        })
    }

    async updateBanners() {
        const { mobileBanners, desktopBanners } = this.state;
        const environmentId = await EnvironmentStorage.getEnvironmentHoldingId();

        this.setState({ loading: true });
        const frontTheme = await EnvironmentsAPI.getConfigurationsByAlias(environmentId, 'front_theme') || {};
        
        frontTheme.covers = {
            mobile: mobileBanners,
            desktop: desktopBanners
        }

        const updateResponse = await EnvironmentsAPI.putConfigurationsByAlias(
            environmentId, 'front_theme', { front_theme: frontTheme }
        );

        if (updateResponse.getErrors([]).length > 0) {
            alert({ text: updateResponse.getErrors()[0], buttonText: "Ok" });
            this.setState({ loading: false });
            return false;
        } else {
            alert({ text: "Banners salvos com sucesso", buttonText: "Ok" });
        }

        this.setState({ loading: false });

        return true;
    }

    onRemoveBanner(bannerIndex, isMobile = true) {
        const { mobileBanners, desktopBanners } = this.state;
        if (isMobile) {
            this.setState({
                mobileBanners: mobileBanners.filter((_, imageIndex) => imageIndex != bannerIndex)
            })
        } else {
            this.setState({
                desktopBanners: desktopBanners.filter((_, imageIndex) => imageIndex != bannerIndex)
            })
        }
    }

    onSwitchPosition(bannerIndex, direction, isMobile = true) {
        const { mobileBanners, desktopBanners } = this.state;
        const newIndex = direction == 'up' ? bannerIndex - 1 : bannerIndex + 1;
        if (isMobile) {
            const currentBannerOnPosition = mobileBanners[bannerIndex];
            const newBannerOnPosition = mobileBanners[newIndex];
            mobileBanners[newIndex] = currentBannerOnPosition;
            mobileBanners[bannerIndex] = newBannerOnPosition;
            this.setState({ mobileBanners });
        } else {
            const currentBannerOnPosition = desktopBanners[bannerIndex];
            const newBannerOnPosition = desktopBanners[newIndex];
            desktopBanners[newIndex] = currentBannerOnPosition;
            desktopBanners[bannerIndex] = newBannerOnPosition;
            this.setState({ desktopBanners });
        }
    }

    render() {
        const { loading, mobileBanners, desktopBanners } = this.state;
        const { visible, onClose } = this.props;

        return (
            <Drawer
                visible={visible}
                onClose={onClose}
                closeInFade
                title="Banners"
            >
                <div className={styles.integration}>
                    <div>
                        <div className={bannerStyles.titleContainer}>
                            <p>Mobile</p>
                        </div>
                        {mobileBanners.map((b, i, bArray) => {
                            return (
                                <div className={bannerStyles.bannerCard} key={i}>
                                    <div className="w-100">
                                        <div className={bannerStyles.image}>
                                            <img src={`${process.env.REACT_APP_ASSETS_URL}/${b}`} />
                                        </div>
                                    </div>
                                    <div className={"d-flex"} style={{ padding: 10 }}>
                                        <div className={`${sortStyles.chevrons} w-100`}>
                                            {i !== 0 ? <Icon name="chevron-up" size="lg" onClick={() => this.onSwitchPosition(i, 'up')} /> : ''}
                                            {i !== bArray.length - 1 ? <Icon name="chevron-down" size="lg" onClick={() => this.onSwitchPosition(i, 'down')} /> : ''}
                                        </div>
                                        <Icon name="trash-alt" size="1x" onClick={() => this.onRemoveBanner(i)} />
                                    </div>
                                </div>
                            )
                        })}
                        <ImageUpload key={`mobile-1`} onImageUpload={(uri) => this.setState({ mobileBanners: [...mobileBanners, uri] })} />
                    </div>
                    <Hairline />
                    <div>
                        <div className={bannerStyles.titleContainer}>
                            <p>Desktop</p>
                        </div>
                        {desktopBanners.map((b, i, bArray) => {
                            return (
                                <div className={bannerStyles.bannerCard} key={i}>
                                    <div className="w-100">
                                        <div className={bannerStyles.image}>
                                            <img src={`${process.env.REACT_APP_ASSETS_URL}/${b}`} />
                                        </div>
                                    </div>
                                    <div className={"d-flex"} style={{ padding: 10 }}>
                                        <div className={`${sortStyles.chevrons} w-100`}>
                                            {i !== 0 ? <Icon name="chevron-up" size="lg" onClick={() => this.onSwitchPosition(i, 'up', false)} /> : ''}
                                            {i !== bArray.length - 1 ? <Icon name="chevron-down" size="lg" onClick={() => this.onSwitchPosition(i, 'down', false)} /> : ''}
                                        </div>
                                        <Icon name="trash-alt" size="1x" onClick={() => this.onRemoveBanner(i, false)} />
                                    </div>
                                </div>
                            )
                        })}
                        <div style={{ marginBottom: 50 }}>
                            <ImageUpload key={`desktop-2`} onImageUpload={(uri) => this.setState({ desktopBanners: [...desktopBanners, uri] })} />
                        </div>
                    </div>
                    <div className={styles.footer}>
                        <Button
                            design="primary"
                            className="w-100"
                            onClick={() => this.updateBanners()}
                            loading={loading}
                            disabled={loading}
                        >
                            Salvar
                        </Button>
                    </div>
                </div>
            </Drawer>
        );
    }
}
